import vSelect from "vue-select";

Vue.component("v-select", vSelect);

Vue.component("expandable", () => import("./compass/Expandable.vue"));
Vue.component(
  "expandable-table-rows",
  () => import("./compass/ExpandableTableRows.vue")
);
Vue.component("school-lookup", () => import("./compass/SchoolLookup.vue"));
Vue.component("autocomplete", () => import("./compass/Autocomplete.vue"));
Vue.component("copy-clipboard", () => import("./compass/CopyClipboard.vue"));
Vue.component("flash", () => import("./compass/Flash.vue"));
Vue.component("confirmation-message", () => import("./compass/Confirmation.vue"));
Vue.component("single-choice", () => import("./compass/questions/SingleChoice.vue"));
Vue.component(
  "multiple-short-text",
  () => import("./compass/questions/MultipleShortText.vue")
);
Vue.component("short-text", () => import("./compass/questions/ShortText.vue"));
Vue.component(
  "multiple-choice",
  () => import("./compass/questions/MultipleChoice.vue")
);
Vue.component("email-preferences", () => import("./compass/EmailPreferences.vue"));
Vue.component("evaluation-actions", () => import("./compass/EvaluationActions.vue"));
Vue.component(
  "evaluation-progress-report",
  () => import("./compass/EvaluationProgressReport.vue")
);
Vue.component(
  "evaluation-copylink",
  () => import("./compass/EvaluationCopylink.vue")
);
Vue.component(
  "evaluation-duplicate",
  () => import("./compass/EvaluationDuplicate.vue")
);
Vue.component("evaluation-delete", () => import("./compass/EvaluationDelete.vue"));
Vue.component("modal", () => import("./compass/Modal.vue"));
Vue.component("ReassignSurvey", () => import("./compass/ReassignSurvey.vue"));
/**
 * Include Vue-tables-2 components, consider changing to Buefy
 *
 */
Vue.component("ViewButtonTemplate", {
  props: ["data"],
  template: `<a class='btn btn-primary' :href='this.data.view'>View</a>`
});
Vue.component("ImpersonateButtonTemplate", {
  props: ["data"],
  template: `<a :href='this.data.impersonate' class='btn btn-primary'>Impersonate</a>`
});
Vue.component("UserSurveysButtonTemplate", {
  props: ["data"],
  template: `<a class='btn' :href="this.data.surveys">Surveys</a>`
});

Vue.component("SurveyIdTemplate", {
  props: ["data"],
  computed: {
    getLink: function() {
      let surveyPath = location.pathname.split('/')[1];
      let link =
        `/${'dashboard' === surveyPath ? 'survey' : surveyPath}/${this.data.id}` +
        (this.data.status === this.$t("compass.status.completed") ? "/results" : "/resume");
      if (this.data.use_share_link) {
        link = this.data.use_share_link;
      }
      return link;
    },
  },
  template: `<a v-if="((data.is_owner || data.user_role.is_school_admin) && !(data.user_role.is_school_viewer || data.user_role.is_division_viewer)) || data.is_completed" :href='getLink'>{{ data.id }}</a> <a v-else> {{ data.id }}</a>`
});

Vue.component("SurveyActionTemplate", {
  props: ["data"],
  // Don't show the button if the user is a viewer and has an a not complete survey (because there will be no options for the user)
  template: `<img v-if="!data.is_completed && ((data.user_role.is_school_viewer || data.user_role.is_division_viewer) || (!data.is_owner && !data.user_role.is_school_admin))" v-rowaction="data" />
  <div v-else-if="data.is_owner || data.is_completed || data.shared || data.user_role.is_school_admin" type="button" v-rowaction="data" class='btn-action mp-btn-action' />`
});

Vue.component(
    "link-division-to-eanr-sites-modal",
  () => import("./compass/eanr-integration/LinkDivisionToEanrSitesModal.vue")
);
